import React from "react"

import { ApiResponse } from "shared/types/ApiResponse"
import { TeamMember } from "shared/types/__generated__/graphql"

import { CreateTeamMemberFormData } from "features/team-member-management/types/CreateTeamMemberFormData"

import { useCreateProjectTeamMembersOverlayViewModel } from "./model/useCreateProjectTeamMembersOverlayViewModel"
import { CreateProjectTeamMembersOverlayView } from "./ui/CreateProjectTeamMembersOverlayView"

export interface CreateProjectTeamMembersOverlayModel {
  defaultValue?: CreateTeamMemberFormData
  currentUserEmail?: string
  existingTeamMemberEmails?: string[]
  onSubmit: (
    formData: CreateTeamMemberFormData
  ) => void | Promise<ApiResponse<TeamMember[]>>
  onCancel: () => void
}

export interface CreateProjectTeamMembersOverlayProps
  extends CreateProjectTeamMembersOverlayModel {
  autoFocus?: boolean
}

export const CreateProjectTeamMembersOverlay = React.memo(
  (props: CreateProjectTeamMembersOverlayProps) => (
    <CreateProjectTeamMembersOverlayView
      {...useCreateProjectTeamMembersOverlayViewModel(props)}
      formID="project-team-invites-overlay-form"
    />
  )
)
